// TaxReturn.status (new/half/full/submitted) never advances past "submitted"
// server-side - the real post-submit IRS outcome is decided asynchronously by
// the scheduler and lands on the efile_queue_2290 hand-off row instead
// (queueStatus: PENDING -> ACK_PENDING -> ACK_RECEIVED, submissionStatus: the
// raw IRS ack text once ACK_RECEIVED). Shared between MyFilings and Dashboard
// so both surfaces read a submitted return's real status the same way.
export const DRAFT_STATUSES = new Set(["new", "half", "full"]);

export function getMergedStatus(row) {
  const sub = (row.submissionStatus || "").toLowerCase();
  if (sub.includes("reject")) return "rejected";
  if (sub.includes("accept") || sub.includes("approv")) return "accepted";
  if (row.queueStatus === "ACK_RECEIVED") return "accepted";
  if (row.queueStatus === "ACK_PENDING") return "submitted";
  if (row.queueStatus === "PENDING") return "submission_with_irs";
  return row.status; // new/half/full - not yet enqueued for transmission
}

export const STATUS_STYLES = {
  new: { label: "Not started", bg: "var(--panel-2)", color: "var(--muted)" },
  half: { label: "In progress", bg: "var(--amber-soft)", color: "var(--amber)" },
  full: { label: "Ready to file", bg: "var(--amber-soft)", color: "var(--amber)" },
  submission_with_irs: { label: "Pending with IRS", bg: "var(--amber-soft)", color: "var(--amber)" },
  submitted: { label: "Submitted", bg: "var(--accent-soft)", color: "var(--accent)" },
  accepted: { label: "Filed", bg: "var(--accent-soft)", color: "var(--accent)" },
  rejected: { label: "Rejected", bg: "var(--danger-soft)", color: "var(--danger)" },
};
